import { render, staticRenderFns } from "./SocialMediaLinks.vue?vue&type=template&id=40f3bf9c&scoped=true&"
import script from "./SocialMediaLinks.vue?vue&type=script&lang=js&"
export * from "./SocialMediaLinks.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaLinks.vue?vue&type=style&index=0&id=40f3bf9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3bf9c",
  null
  
)

export default component.exports